import {useEffect, useState} from "react";
import {ReportForm} from "@/types/ReportForm.ts";
import {useParams} from "react-router-dom";
import {Header} from "@/components/Header.tsx";
import {PoweredBy} from "@/components/PoweredBy.tsx";

export const FormSuccess = () => {
  const {id} = useParams();
  const [reportForm, setReportForm] = useState<ReportForm | null>(null);
  useEffect(() => {
    if (!id) return;
    ReportForm.fetchReportForm({form_id: id}).then((reportForm) => {
      setReportForm(reportForm);
    });
  }, [id]);

  if (!reportForm) return null;

  return (
    <div>
      <Header reportForm={reportForm}/>
      <h1 className="text-xl font-semibold text-gray-700">
        Thank you for submitting your report!
      </h1>
      <h2 className={"mt-8"}>
        Our team will review your submission and get back to you if we have any questions.
      </h2>
      <PoweredBy/>
    </div>
  );
}
